<app-loader [isLoading]="loading()"/>
<mat-dialog-content>
    <mat-dialog-content>
        <div>
            <p>
                Поменять заявки {{data.worker.firstName}} {{data.worker.lastName || ''}} с
            </p>

            <app-person-selector [formCtrl]="workerToReplace" [additionalParams]="personAdditionalParams" [label]="'Исполнитель'"/>

        </div>
        <div class="flex justify-between">
            <button mat-stroked-button class="w-40" color="basic" (click)="close()">Отменить</button>
            <button mat-flat-button class="w-40" color="primary" [disabled]="!workerToReplace.value" (click)="submit(workerToReplace.value)">Сохранить</button>
        </div>
    </mat-dialog-content>
</mat-dialog-content>
